import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "@/components/ScrollToTop";
import ErrorBoundary from "@/components/ErrorBoundary";
import { UserProvider } from "@/context/UserContext";
import { NotificationProvider } from "@/context/NotificationContext";
import ToastContainer from "@/components/ui/ToastContainer";
import CatererRoutes from "@/CatererRoutes";

function App() {
  return (
    <UserProvider>
      <BrowserRouter>
        <ErrorBoundary>
          <NotificationProvider>
            <ScrollToTop />
            <RouterRoutes>
              <Route path="*" element={<CatererRoutes />} />
            </RouterRoutes>
            <ToastContainer />
          </NotificationProvider>
        </ErrorBoundary>
      </BrowserRouter>
    </UserProvider>
  );
}

export default App;
